import TSvgProps from './type/svgPropsType'

interface IFProps extends TSvgProps {
  isFilled?: boolean
}

const Heart = ({ isFilled = false, ...props }: IFProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    {...props}
  >
    <desc>관심</desc>

    <g fill="none" data-name="그룹 50632">
      <path d="M0 0h24v24H0z" data-name="사각형 34551"></path>
      <path
        stroke={isFilled ? '#f46161' : '#666'}
        fill={isFilled ? '#f46161' : 'none'}
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M18.121 3.396c-2.3-.717-4.6 1.338-6.125 3.2-1.52-1.858-3.853-3.945-6.125-3.2-2.981 1.142-4.215 5.007-3.069 8.256s9.194 9.107 9.194 9.107 8.048-5.859 9.194-9.107a7.26 7.26 0 0 0-.567-6.153 4.77 4.77 0 0 0-2.502-2.103z"
        data-name="패스 17408"
      ></path>
    </g>
  </svg>
)

export default Heart
